
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.707.293A1 1 0 00.293 1.707L8.586 10 .293 18.293a1 1 0 101.414 1.414L10 11.414l8.293 8.293a1 1 0 001.414-1.414L11.414 10l8.293-8.293A1 1 0 0018.293.293L10 8.586 1.707.293z","fill":"#000"}})])
          )
        }
      }
    